export enum ExportType {
    SUPPLIER_INVOICES = 'SUPPLIER_INVOICES',
    BUYER_INVOICES = 'BUYER_INVOICES',
    BUYER_ACCOUNT_INVOICES = 'BUYER_ACCOUNT_INVOICES',
    BUYER_PAY_LATER = 'BUYER_PAY_LATER',
    BUYER_PAYMENT = 'BUYER_PAYMENT',
    SUPPLIER_PAYMENT = 'SUPPLIER_PAYMENT',
    BUYER_SUPPLIERS = 'BUYER_SUPPLIERS',
    BUYER_CURRENT_BALANCE = 'BUYER_CURRENT_BALANCE',
    SUPPLIER_EARLY_PAYMENT = 'SUPPLIER_EARLY_PAYMENT'
}
